import React, {useContext} from "react";
import UserContext from "../../common/UserContext";
import {AssignedProductContext, GeneralContext, SelectedProductContext} from "../FSARequestLicenseContext";
import {useLocalization} from "@progress/kendo-react-intl";
import {GridColumn} from "@progress/kendo-react-grid";
import {
    assignQtyKey,
    descriptionKey,
    endDateKey,
    licenseTypeKey,
    mainMessages,
    productNumberKey,
    qtyKey, startDateKey
} from "../../../assets/text/MultilingualText";
import {
    ColumnMenu,
    ColumnSortOnlyMenu,
    DateCell,
    NoWrapCell,
    TextAlignMiddleCell
} from "../../common/Grid";
import {AssignProductQtyCell} from "./AssignProductQtyCell";
import GenericSelectSortGrid from "../../common/AssignHost/GenericSelectSortGrid";

export const AssignProductsGrid = (props) => {
    const {
        siteLanguageDefault,
    } = useContext(UserContext);

    const {
        initialGridState,
        uniqueID,
        productNumKey,
        licenseStartDateKey,
        licenseEndDateKey,
    } = useContext(GeneralContext);

    const {
        selectedProducts: items,
        setSelectedProducts: setItems,
    } = useContext(SelectedProductContext);

    const {
        assignSelectID: selectID,
        assignedGridState: gridState,
        setAssignedGridState: setGridState,
        assignedGridStateRef: gridStateRef,
        assignedHeaderCheck: selectHeaderCheck,
        setAssignedHeaderCheck: setSelectHeaderCheck,
        disableArrayID,
        sortByDisableID,
        sortByDisableID2,
        sortByDisableValue,
        sortByDisableValue2,
        enableSortByDisable,
        setEnableSortByDisable,
    } = useContext(AssignedProductContext);

    const localization = useLocalization();

    // update product state for editable assign qty in license table
    const onItemChange = (e) => {
        let newItems = items.map((item) => {
            if (item[uniqueID] === e.dataItem[uniqueID]) {
                let setValue = parseInt(e.value)

                // assign qty cannot be greater than the max qty available
                if (setValue > parseInt(e.dataItem.unassigned_quantity)) {
                    setValue = parseInt(e.dataItem.unassigned_quantity)
                }
                // assign qty cannot be less than 1
                if (setValue < 1) {
                    setValue = null
                }

                item[e.field] = setValue;
            }
            return item;
        });

        setItems(newItems);
    };

    return (
        <GenericSelectSortGrid
            className={'fsa-assign-products-grid'}
            selectID={selectID}
            items={items}
            setItems={setItems}
            uniqueID={uniqueID}
            initialGridState={initialGridState}
            gridState={gridState}
            setGridState={setGridState}
            gridStateRef={gridStateRef}
            selectHeaderCheck={selectHeaderCheck}
            setSelectHeaderCheck={setSelectHeaderCheck}
            disableArrayID={disableArrayID}
            sortByDisableID={sortByDisableID}
            sortByDisableID2={sortByDisableID2}
            sortByDisableValue={sortByDisableValue}
            sortByDisableValue2={sortByDisableValue2}
            enableSortByDisable={enableSortByDisable}
            setEnableSortByDisable={setEnableSortByDisable}
            onItemChange={onItemChange}
            filterOut={(item) => item.unassigned_quantity > 0}
        >
            <GridColumn
                field={productNumKey}
                title={localization.toLanguageString(productNumberKey, mainMessages[siteLanguageDefault][productNumberKey])}
                cell={NoWrapCell}
                columnMenu={ColumnMenu}
            />

            <GridColumn
                field="description"
                title={localization.toLanguageString(descriptionKey, mainMessages[siteLanguageDefault][descriptionKey])}
                columnMenu={ColumnMenu}
            />

            <GridColumn
                field="unassigned_quantity"
                title={localization.toLanguageString(qtyKey, mainMessages[siteLanguageDefault][qtyKey])}
                cell={TextAlignMiddleCell}
                filter={'numeric'}
                columnMenu={ColumnSortOnlyMenu}
            />

            <GridColumn
                field="assign_quantity"
                title={localization.toLanguageString(assignQtyKey, mainMessages[siteLanguageDefault][assignQtyKey])}
                filter={'numeric'}
                cell={AssignProductQtyCell}
                sortable={false}
            />

            <GridColumn
                field="selected_license_type_text"
                title={localization.toLanguageString(licenseTypeKey, mainMessages[siteLanguageDefault][licenseTypeKey])}
                cell={NoWrapCell}
                columnMenu={ColumnMenu}
            />

            <GridColumn
                field={licenseStartDateKey}
                title={localization.toLanguageString(startDateKey, mainMessages[siteLanguageDefault][startDateKey])}
                filter={'date'}
                columnMenu={ColumnMenu}
                cell={DateCell}
            />

            <GridColumn
                field={licenseEndDateKey}
                title={localization.toLanguageString(endDateKey, mainMessages[siteLanguageDefault][endDateKey])}
                filter={'date'}
                columnMenu={ColumnMenu}
                cell={DateCell}
            />
        </GenericSelectSortGrid>
    )
}